import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import moment from 'moment';
import { runInAction } from 'mobx';
import * as Colors from '../themes/summaryReportColor';

const movementData = [
  { hour: 0 },
  { hour: 1 },
  { hour: 2 },
  { hour: 3 },
  { hour: 4 },
  { hour: 5 },
  { hour: 6 },
  { hour: 7 },
  { hour: 8 },
  { hour: 9 },
  { hour: 10 },
  { hour: 11 },
  { hour: 12 },
  { hour: 13 },
  { hour: 14 },
  { hour: 15 },
  { hour: 15 },
  { hour: 16 },
  { hour: 17 },
  { hour: 19 },
  { hour: 20 },
  { hour: 21 },
  { hour: 22 },
  { hour: 23 },
];

const chartData = [
  [
    'Walking',
    // '#fadbae',
    new Date(2019, 1, 1, 0, 1, 0),
    new Date(2019, 1, 1, 0, 1, 0),
  ],
  [
    'Standing',
    // '#b6d4d9',
    new Date(2019, 1, 1, 0, 1, 0),
    new Date(2019, 1, 1, 0, 1, 0),
  ],
  [
    'Walking',
    // '#fadbae',
    new Date(2019, 1, 1, 2, 0, 0),
    new Date(2019, 1, 1, 4, 30, 0),
  ],
  [
    'Standing',
    // '#b6d4d9',
    new Date(2019, 1, 1, 4, 30, 0),
    new Date(2019, 1, 1, 5, 0, 0),
  ],
  [
    'Sitting',
    // '#d2d9b0',
    new Date(2019, 1, 1, 5, 0, 0),
    new Date(2019, 1, 1, 5, 20, 0),
  ],
  [
    'Lying on right side',
    // '#d1cfe7',
    new Date(2019, 1, 1, 5, 20, 0),
    new Date(2019, 1, 1, 7, 0, 0),
  ],
  [
    'Lying on left side',
    // '#d1cfe7',
    new Date(2019, 1, 1, 7, 0, 0),
    new Date(2019, 1, 1, 8, 0, 0),
  ],
  [
    'Walking',
    // '#fadbae',
    new Date(2019, 1, 1, 8, 0, 0),
    new Date(2019, 1, 1, 10, 0, 0),
  ],
  [
    'Lying on back',
    // '#d1cfe7',
    new Date(2019, 1, 1, 10, 0, 0),
    new Date(2019, 1, 1, 12, 0, 0),
  ],
  [
    'Sitting',
    // '#d2d9b0',
    new Date(2019, 1, 1, 12, 0, 0),
    new Date(2019, 1, 1, 14, 20, 0),
  ],
  [
    'Lying on stomach',
    // '#d1cfe7',
    new Date(2019, 1, 1, 14, 20, 0),
    new Date(2019, 1, 1, 20, 0, 0),
  ],
  [
    'Sitting',
    // '#d2d9b0',
    new Date(2019, 1, 1, 20, 0, 0),
    new Date(2019, 1, 1, 24, 0, 0),
  ],
];

const alertData = [];
const locationData = [];
const batteryData = [];
const deviceData = [];

export class SummaryReportStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      loadingAlert: false,
      loadingActivity: false,
      loadingMovement: false,
      loadingAvailableDate: false,
      loadingLocation: false,
      loadingBattery: false,
      loadingDevice: false,
      loadingSummary: false,
      // chartData: [...chartData],
      // movementData: [...movementData],
      locationData: [...locationData],
      batteryData: [...batteryData],
      deviceData: [...deviceData],
      date: '',
      dates: [],
      alerts: [...alertData],
      energy: 0,
      checkingTodayData: false,
      hasDataToday: false,
      dataPieChart: [],
      countTime: 0,
      dateSOS: [],
      dateMotionTracker: [],
      dateBeaconTag: [],
      dateVitalSigns: [],
      highlightDate: [],
      includeDate: [],
      assignedDevicesDate: [],
      alertsHasData: [],

      // summary: [],
      // summarySleepPeriod: [],
      // summaryEventPeriod: [],
      chartChanged: false,
      movementChanged: false,
      alertChanged: false,
      locationChanged: false,
      deviceChanged: false,
      batteryChanged: false,
      summaryChanged: false,
      sleepChanged: false,
      eventChanged: false,
    });
    this.chartData = [...chartData];
    this.movementData = [...movementData];
    this.summary = [];
    this.summarySleepPeriod = [];
    this.summaryEventPeriod = [];
    this.summaryLocationPeriod = [];
    // this.vitalsignDate = []
  }

  resetSummary(dates) {
    runInAction(() => {
      const date = new Date();
      const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
      this.chartData = this.calculateChartData([], dateFormate);
      this.movementData = this.calculateMovementData([], dateFormate);
      this.alerts = this.calculateAlertData([], dateFormate);
      // this.alertsHasData = [];
      this.locationData = [...locationData];
      this.deviceData = [...deviceData];
      this.energy = 0;
      this.dates = dates ? [] : this.dates;
      this.batteryData = [];
      this.countTime = 0;
      this.dataPieChart = [];
      this.highlightDate = dates ? [] : this.highlightDate;
      this.includeDate = dates ? [] : this.includeDate;
      this.assignedDevicesDate = dates ? [] : this.assignedDevicesDate;
      this.dateVitalSigns = dates ? [] : this.dateVitalSigns;
    });
  }

  async getSummary(id, date, queryOption) {
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    runInAction(() => {
      this.date = date;
      this.chartData = this.calculateChartData([], dateFormate);
      this.movementData = this.calculateMovementData([], dateFormate);
      this.alerts = this.calculateAlertData([], dateFormate);
      if (queryOption.activity) {
        this.hasDataToday = true;
      }
    });
    try {
      this.setLoadingStatus(queryOption, true);

      let url = `${config.api.url}/${config.api.version}/eventlog/summary/${id}/date/${dateFormate}`;
      const res = await rp
        .get({
          uri: url,
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        runInAction(() => {
          const resp = res.body;
          if (queryOption.activity) {
            const chartData = resp['action'];
            this.chartData = this.calculateChartData(chartData, dateFormate);
            // this.calculatePieChart(chartData);
            this.chartChanged = !this.chartChanged;
          }

          if (queryOption.movement) {
            const movementData = resp['movement'];
            this.movementData = this.calculateMovementData(movementData, dateFormate);
            this.movementChanged = !this.movementChanged;
          }

          if (queryOption.energy) {
            this.energy = resp['energy'];
          }

          if (queryOption.location) {
            const locationData = resp['location'];
            this.locationData = this.calculateLocation(locationData, dateFormate);
          }

          if (queryOption.alert) {
            const alerts = resp['alert'];
            this.alerts = this.calculateAlertData(alerts, dateFormate);
            this.alertsHasData = (this.alerts || []).filter((a) => a.data.length > 0);
          }

          if (queryOption.availableDate) {
            const dates = resp['availableDate'];
            this.hasDataToday = false;

            const today = moment().startOf('d');
            const foundToday = dates.find((val) => {
              const datesame = moment(new Date(val));
              return datesame.isSame(today);
            });
            this.hasDataToday = foundToday ? true : false;
            this.checkingTodayData = false;

            const highlightDate = [];
            const includeDate = [];
            dates.forEach((val) => {
              const dt = new Date(val);
              highlightDate.push({
                'react-datepicker__quarter-text--highlighted': [dt],
              });
              includeDate.push(dt);
            });
            this.highlightDate = highlightDate;
            this.includeDate = includeDate;
          }

          if (queryOption.battery) {
            const batteryData = resp['battery'];
            this.batteryData = this.calculateBattery(batteryData, dateFormate);
          }

          if (queryOption.device) {
            const deviceData = resp['device'];
            const tmp = this.calculateDevice(deviceData, dateFormate);
            this.deviceData = tmp;
          }
        });
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.setLoadingStatus(queryOption, false);
    }
  }

  async getDeviceUsage(id, date) {
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    try {
      this.setLoadingStatus({ device: true }, true);

      let url = `${config.api.url}/${config.api.version}/assigneddevicedate/date/${dateFormate}/patient/${id}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        const resp = res.body;
        this.deviceData = this.calculateDevice(resp, dateFormate);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.setLoadingStatus({ device: true }, false);
    }
  }

  async getGraphAvailableDate(patientId) {
    runInAction(() => {
      this.checkingTodayData = true;
      this.loadingAvailableDate = true;
      this.hasDataToday = false;
    });
    try {
      this.setLoadingStatus({ availableDate: true }, true);

      let url = `${config.api.url}/${config.api.version}/graphavailabledate/patient/${patientId}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        const resp = res.body || {};
        runInAction(() => {
          if (resp['availableDate'].length > 0) {
            const dates = resp['availableDate'];
            this.hasDataToday = false;

            const today = moment().startOf('d');
            const foundToday = dates.find((val) => {
              const datesame = moment(new Date(val));
              return datesame.isSame(today, 'day');
            });
            this.hasDataToday = foundToday ? true : false;
            this.checkingTodayData = false;

            const includeDate = [];

            dates.forEach((val) => {
              const dt = new Date(val);
              const dateFormat = moment(dt).format('YYYY-MM-DD');
              includeDate.push(dateFormat);
            });
            if (includeDate.length > 0) {
              let tmp = this.includeDate;
              if (tmp.length > 0) {
                tmp = tmp.concat(includeDate);
                tmp = tmp.filter((item, pos) => tmp.indexOf(item) === pos);
                this.includeDate = tmp;
              } else {
                this.includeDate = includeDate;
              }
            }
          }
        });
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.setLoadingStatus({ availableDate: true }, false);
    }
  }

  async getAssignedDeviceDate(patientId) {
    try {
      let url = `${config.api.url}/${config.api.version}/assigneddevicedate/dates/patient/${patientId}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        const resp = res.body || {};
        const assignedDevicesDate = [];
        const dateMotionTracker = [];
        const dateSOS = [];
        const dateBeaconTag = [];
        const includeDate = this.includeDate;

        resp.forEach((val) => {
          const dt = new Date(val.date);
          const dateFormat = moment(dt).format('YYYY-MM-DD');

          //prepare data for assignedDevices
          const hasAssignedDevices = val.devices && val.devices.length > 0;
          const assignedDevices = {
            date: dt,
            assignedDevices: hasAssignedDevices ? val.devices.filter((v) => v).map((v) => v.name) : [],
            reportOptions: {
              hasActivity: hasAssignedDevices ? this.hasReport(val.devices, 'motionTracker') : true,
              hasLocalization: hasAssignedDevices ? this.hasReport(val.devices, 'localization') : true,
            },
          };
          assignedDevicesDate.push(assignedDevices);

          const date = (includeDate || []).find((d) => d === dateFormat);
          // assigned date
          if (date) {
            if (!hasAssignedDevices) {
              dateMotionTracker.push(dateFormat);
            } else {
              if (this.hasReport(val.devices, 'motionTracker')) {
                dateMotionTracker.push(dateFormat);
              }
              if (this.hasReport(val.devices, 'alarmTrigger') || this.hasReport(val.devices, 'alarmOnoff')) {
                dateSOS.push(dateFormat);
              }
              if (
                this.hasReport(val.devices, 'localization') &&
                !this.hasReport(val.devices, 'motionTracker') &&
                !this.hasReport(val.devices, 'alarmTrigger') &&
                !this.hasReport(val.devices, 'alarmOnoff')
              ) {
                dateBeaconTag.push(dateFormat);
              }
            }
          }
        });

        this.assignedDevicesDate = assignedDevicesDate;
        this.dateMotionTracker = dateMotionTracker;
        this.dateSOS = dateSOS;
        this.dateBeaconTag = dateBeaconTag;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
    }
  }

  hasReport(devices, reportType) {
    const found = devices.filter((d) => {
      if (!d || !d.deviceType) {
        return false;
      }

      const deviceProperty = d.deviceType['property'];
      if (deviceProperty) {
        return deviceProperty[reportType] === 1;
      }

      return false;
    });
    return found.length > 0;
  }

  async getVitalSignDate(patientId) {
    let url = `${config.api.url}/${config.api.version}/vitalsign/dates/patient/${patientId}`;
    const res = await rp
      .get({
        uri: url,
        authorization: true,
        resolveWithFullResponse: true,
        json: true,
        headers: {
          ...getTenantHeaders(),
        },
      })
      .auth(null, null, true, getToken('id_token'));
    if (res && res.statusCode === 200) {
      const data = res.body || [];
      if (data.length > 0) {
        let tmp = this.includeDate;
        if (tmp.length > 0) {
          tmp = tmp.concat(data);
          tmp = tmp.filter((item, pos) => tmp.indexOf(item) === pos);
          this.includeDate = tmp;
        } else {
          this.includeDate = data;
        }
        // concat vitalsign date
        tmp = this.dateVitalSigns;
        if (tmp.length > 0) {
          tmp = tmp.concat(data);
          tmp = tmp.filter((item, pos) => tmp.indexOf(item) === pos);
          this.dateVitalSigns = tmp;
        } else {
          this.dateVitalSigns = data;
        }
      }
    }
  }

  async getGarminDate(patientId) {
    this.loading = true;
    try {
      const url = `${config.api.url}/${config.api.version}/smartwatch/garmin/summary/dates/patient/${patientId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const data = res.body || [];
        if (data.length > 0) {
          let tmp = this.includeDate;
          if (tmp.length > 0) {
            tmp = tmp.concat(data);
            tmp = tmp.filter((item, pos) => tmp.indexOf(item) === pos);
            this.includeDate = tmp;
          } else {
            this.includeDate = data;
          }

          // concat vitalsign date
          tmp = this.dateVitalSigns;
          if (tmp.length > 0) {
            tmp = tmp.concat(data);
            tmp = tmp.filter((item, pos) => tmp.indexOf(item) === pos);
            this.dateVitalSigns = tmp;
          } else {
            this.dateVitalSigns = data;
          }
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
  async getSummaryReport(id, date) {
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    runInAction(() => {
      this.date = date;
    });
    this.loadingSummary = true;
    try {
      let url = `${config.api.url}/${config.api.version}/activitysummary/${id}/as/date/${dateFormate}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        const resp = res.body;
        this.summary = resp;
        this.summaryChanged = !this.summaryChanged;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loadingSummary = false;
    }
  }

  async getSummaryReportAsPeriod(id, date, unitPeriod, types) {
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    runInAction(() => {
      this.date = date;
    });
    try {
      let url = `${config.api.url}/${config.api.version}/activitysummary/${id}/as/${unitPeriod}/${dateFormate}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const resp = res.body;
        if (types.includes('sleep')) {
          this.summarySleepPeriod = resp;
          this.sleepChanged = !this.sleepChanged;
        }
        if (types.includes('event')) {
          this.summaryEventPeriod = resp;
          this.eventChanged = !this.eventChanged;
        }
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      // this.setLoadingStatus(queryOption, false);
    }
  }

  async getSummaryLocationAsPeriod(id, date, unitPeriod) {
    const dateFormate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    runInAction(() => {
      this.date = date;
      this.summaryLocationPeriod = [];
    });
    try {
      let url = `${config.api.url}/${config.api.version}/locationsummary/${id}/as/${unitPeriod}/${dateFormate}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const resp = res.body;
        this.summaryLocationPeriod = resp;
        this.locationChanged = !this.locationChanged;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      // this.setLoadingStatus(queryOption, false);
    }
  }

  setLoadingStatus(queryOption, status) {
    runInAction(() => {
      if (queryOption.alert) {
        this.loadingAlert = status;
      }
      if (queryOption.activity) {
        this.loadingActivity = status;
      }
      if (queryOption.movement) {
        this.loadingMovement = status;
      }
      if (queryOption.location) {
        this.loadingLocation = status;
      }
      if (queryOption.battery) {
        this.loadingBattery = status;
      }
      if (queryOption.device) {
        this.loadingDevice = status;
      }
      if (queryOption.availableDate) {
        this.loadingAvailableDate = status;
      }
    });
  }

  getUTCDateTime(dateTime) {
    return dateTime.getTime() - dateTime.getTimezoneOffset() * 60 * 1000;
  }

  getNumberActivity(eventName) {
    let value = 7;
    switch (eventName) {
      case 'Lying on stomach':
        value = 6;
        break;
      case 'Lying on back':
        value = 5;
        break;
      case 'Lying on left side':
        value = 4;
        break;
      case 'Lying on right side':
        value = 3;
        break;
      case 'Sitting':
        value = 2;
        break;
      case 'Standing':
        value = 1;
        break;
      case 'Walking':
        value = 0;
        break;
      default:
        value = 7;
        break;
    }
    return value;
  }

  getAlertSerieData(alerts, alertType, showInLegend = true) {
    let color = '#ffffff';
    let name = ' ';

    switch (alertType) {
      case 501:
        color = Colors.COLOR_ALERT_GETUP;
        name = 'Getup';
        break;
      case 502:
        color = Colors.COLOR_ALERT_MOVEMENT;
        name = 'Movement';
        break;
      case 506:
        color = Colors.COLOR_ALERT_NOT_TURN_FOR;
        name = 'Not Turn';
        break;
      case 507:
        color = Colors.COLOR_ALERT_NO_MOVEMENT_FOR;
        name = 'No Movement For';
        break;
      case 508:
        color = Colors.COLOR_ALERT_FALL;
        name = 'Fall';
        break;
      case 509:
        color = Colors.COLOR_ALERT_OUT_OF_AREA;
        name = 'Exit';
        break;
      case 510:
        color = Colors.COLOR_ALERT_INTO_AREA;
        name = 'Get Near';
        break;
      case 511:
        color = Colors.COLOR_ALERT_WALKING_AT_NIGHT;
        name = 'Walking';
        break;
      case 514:
        color = Colors.COLOR_ALERT_EMERGENCY_ALARM;
        name = 'Emergency';
        break;
      default:
        break;
    }

    const datas = (alerts || []).map((val) => {
      return {
        x: this.getUTCDateTime(new Date(val.timestamp)),
        y: 0,
        color,
        name,
        label: name,
        description: val.alertInfo ? val.alertInfo : '',
      };
    });

    const serieData = {
      name,
      showInLegend: !showInLegend ? showInLegend : alerts && alerts.length > 0,
      color,
      dataLabels: {
        allowOverlap: false,
        format:
          '<span style="color:{point.color}">● </span><span style="font-weight: bold;" > ' +
          '{point.x:%A, %b %d, %H:%M:%S}</span><br/>{point.label}',
      },
      marker: {
        symbol: 'circle',
        radius: 4,
      },
      enableMouseTracking: !showInLegend ? showInLegend : alerts && alerts.length > 0,
      data: datas,
    };

    return serieData;
  }

  calculatePieChart(chartData) {
    // 1st
    let sumDateTime = chartData.map((value) => {
      let data = {};
      data['name'] = value.eventName;
      data['value'] = (new Date(value.end).getTime() - new Date(value.start).getTime()) / 100;
      return data;
    });

    // 2nd
    const uniqueArrayWithCounts = sumDateTime.reduce((accum, val) => {
      const dupeIndex = accum.findIndex((arrayItem) => arrayItem.name === val.name);
      if (dupeIndex === -1) {
        accum.push({
          value: val.value,
          ...val,
        });
      } else {
        accum[dupeIndex].value += val.value;
      }
      return accum;
    }, []);

    // 3th

    const dataAllActions = uniqueArrayWithCounts.map((val) => {
      let second = parseFloat(val.value / 10).toFixed(0);
      let hours = val.value / 60 / 60;
      let minutes = val.value % 60;
      let time = hours / 10 + '.' + minutes;
      let number = parseFloat(time);
      this.countTime = +this.countTime + +second;
      return [val.name, parseFloat(number.toFixed(2))];
    });

    // 4th
    if (dataAllActions.length > 0) {
      const groupedActions = ['Lying on right side', 'Lying on left side', 'Lying on back', 'Lying on stomach'];
      const allLying = (dataAllActions || []).filter((action) => groupedActions.includes(action[0]));
      const allLyingSummaryTime = (allLying || []).reduce((total, item) => total + (item[1] || 0), 0);

      this.dataPieChart = (dataAllActions || []).filter((action) => !groupedActions.includes(action[0]));
      this.dataPieChart.push(['Lying', allLyingSummaryTime]);
    } else {
      this.dataPieChart = [];
    }
  }

  calculateAlertData(alerts, date) {
    let alertResult = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    const mockStart = { timestamp: startDate, alertType: 0 };
    const mockEnd = { timestamp: endDate, alertType: 0 };

    const mockAlert = this.getAlertSerieData([mockEnd, mockStart], 0, alerts.length === 0);
    alertResult.push(mockAlert);

    const alertTypes = [501, 502, 506, 507, 508, 509, 510, 511, 514];
    alertTypes.forEach((type) => {
      const tmps = this.getAlertSerieData(
        (alerts || []).filter((value) => value.alertType === type),
        type,
        true,
      );
      tmps && alertResult.push(tmps);
    });

    return alertResult;
  }

  calculateChartData(activity, date) {
    let activityResult = [];

    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    activityResult.push({
      x: this.getUTCDateTime(startDate),
      x2: this.getUTCDateTime(startDate) + 1,
    });

    const y = [0, 1, 2, 3, 4, 5, 6];
    y.forEach((val) => {
      activityResult.push({
        y: val,
        x: this.getUTCDateTime(startDate),
        x2: this.getUTCDateTime(startDate) + 1,
      });
    });

    activity.forEach((val) => {
      activityResult.push({
        x: this.getUTCDateTime(new Date(val.start)),
        x2: this.getUTCDateTime(new Date(val.end)),
        y: this.getNumberActivity(val.eventName),
        loc: val.location,
      });
    });

    activityResult.push({
      x: this.getUTCDateTime(endDate),
      x2: this.getUTCDateTime(endDate),
    });

    return activityResult;
  }

  calculateMovementData(movement, date) {
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    let movementResult = [];
    movementResult.push([this.getUTCDateTime(startDate), 0]);
    let i = 0;
    movement.forEach((val) => {
      i++;
      if (i === movement.length) {
        movementResult.push([this.getUTCDateTime(new Date(val.timestamp)), +val.value]);
        movementResult.push([this.getUTCDateTime(new Date(val.timestamp)), 0]);
      } else {
        movementResult.push([this.getUTCDateTime(new Date(val.timestamp)), +val.value]);
      }
    });
    movementResult.push([this.getUTCDateTime(endDate), 0]);

    return movementResult;
  }

  calculateLocation(locations, date) {
    let locationResult = [];

    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);
    if (locations.length > 0) {
      let result = locations.map((val) => {
        let locationData = [];
        const locationNames = [];

        const mockBegin = {
          x: this.getUTCDateTime(startDate),
          x2: this.getUTCDateTime(startDate) + 1,
        };
        const mockEnd = {
          x: this.getUTCDateTime(endDate),
          x2: this.getUTCDateTime(endDate),
        };

        // if (val.data.length === 0) {
        //   mockBegin.y = 0
        //   mockEnd.y = 0
        //   locationNames.push('-')
        // }

        // locationData.push(mockBegin);
        if (val.data.length > 0) {
          locationData.push(mockBegin);
          (val.data || []).forEach((d) => {
            // const location = d.location ? d.location : "Unknown";
            locationNames.push(d.location);

            locationData.push({
              x: this.getUTCDateTime(new Date(d.start)),
              x2: this.getUTCDateTime(new Date(d.end)),
              y: d.value,
            });
          });
          locationData.push(mockEnd);
        }

        // locationData.push(mockEnd);

        val.data = locationData;
        val.uniqueNames = [...new Set(locationNames)];
        val.uniqueNames = val.uniqueNames.sort((a, b) => (a < b ? -1 : b < a ? 1 : 0));
        return val;
      });

      result = result.sort((a, b) => {
        if (a.data.length > 0 && b.data.length === 0) return -1;
        if (a.data.length === 0 && b.data.length > 0) return 1;
        let deviceNameA = a.deviceName;
        let deviceNameB = b.deviceName;
        deviceNameA = deviceNameA.toLowerCase();
        deviceNameB = deviceNameB.toLowerCase();
        if (deviceNameA < deviceNameB) return -1;
        if (deviceNameA > deviceNameB) return 1;
        return 0;
      });
      locationResult = result;
    }

    return locationResult;
  }

  calculateBattery(battery, date) {
    let batteryResult = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);
    const uniqDevices = this.getUniqDeviceWithColor(battery);

    if (uniqDevices.length > 0) {
      uniqDevices.forEach((u) => {
        const rawData = battery.find((b) => u.name === b.deviceName);
        // batteryResult = rawData.map((val) => {
        let batteryData = [];

        batteryData.push({
          x: this.getUTCDateTime(startDate),
        });

        (rawData.data || []).forEach((d) => {
          batteryData.push({
            x: this.getUTCDateTime(new Date(d.start)),
            y: parseInt(d.value),
          });
        });

        batteryData.push({
          x: this.getUTCDateTime(endDate),
        });

        rawData.data = batteryData;
        rawData.color = u.color;
        batteryResult.push(rawData);
        // return val;
        // });
      });
    }

    return batteryResult;
  }

  calculateDevice(devices, date) {
    let deviceResult = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    // get unique of devices
    let uniqDevices = this.getUniqDeviceWithColor(devices);

    if (uniqDevices.length > 0) {
      deviceResult.push({
        x: this.getUTCDateTime(startDate),
        x2: this.getUTCDateTime(startDate) + 1,
      });

      uniqDevices.forEach((u, index) => {
        const data = devices.filter((d) => d.deviceName === u.name);

        data.forEach((val) => {
          deviceResult.push({
            x: this.getUTCDateTime(new Date(val.start)),
            x2: this.getUTCDateTime(new Date(val.end)),
            y: index,
            color: u.color,
          });
        });
      });

      deviceResult.push({
        x: this.getUTCDateTime(endDate),
        x2: this.getUTCDateTime(endDate),
      });

      uniqDevices = uniqDevices.map((d) => {
        return d.name.length > 18 ? `${d.name.substring(0, 15)}...` : d.name;
      });
    }
    return { data: deviceResult, uniqueNames: uniqDevices };
  }

  getUniqDeviceWithColor(devices) {
    if (devices.length === 0) {
      return [];
    }

    let resultDevice = [];
    let categoryList = (devices || []).map((d) => d.deviceCategory);
    categoryList = categoryList.filter((v, index) => categoryList.indexOf(v) === index);

    categoryList.forEach((category) => {
      let data = devices.filter((d) => d.deviceCategory === category);
      data = data.sort((a, b) => (a.end < b.end ? 1 : b.end < a.end ? -1 : 0));

      const uniqDevices = [];
      data.forEach((d) => {
        const tmp = uniqDevices.find((u) => u.deviceName === d.deviceName);
        if (!tmp) {
          uniqDevices.push(d);
        }
      });

      if (category === 'AIRNODE') {
        uniqDevices[0].color = Colors.COLOR_DEVICE_AIRNODE;
      } else if (category === 'EMERGENCY_BUTTON') {
        uniqDevices[0].color = Colors.COLOR_DEVICE_EMERGENCY;
      } else if (category === 'BEACON_TAG') {
        uniqDevices[0].color = Colors.COLOR_DEVICE_BEACON;
      }

      resultDevice = resultDevice.concat(uniqDevices);
    });

    resultDevice = resultDevice.sort((a, b) =>
      a.deviceName > b.deviceName ? 1 : b.deviceName > a.deviceName ? -1 : 0,
    );

    return resultDevice.map((v) => {
      return {
        name: v.deviceName,
        color: v.color ? v.color : null,
      };
    });
  }
}

export default new SummaryReportStore();
